import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "@/firebase";

/**
 * Registro de traslados entre espacios de trabajo del mismo NIT. Cada traslado lo guarda la Cloud Function
 * `trasladarVinculacion` (functions/src/modules/empresas/vinculaciones/services/vinculaciones-traslado.service.js)
 * con el espacio de donde salió la persona (`idEmpresa.anterior`) y al que llegó (`idEmpresa.nueva`).
 */
const COLECCION = "riskmann_trabajadores_trasladados";

const vigentes = (instantanea) =>
  instantanea.docs
    .map((documento) => ({ id: documento.id, ...documento.data() }))
    .filter((traslado) => !(traslado.registro && traslado.registro.estado === "Eliminado"));

/** Momento del traslado en milisegundos (0 si no lo tiene), para ordenar del más reciente al más antiguo. */
export const momentoTraslado = (traslado) => {
  const creacion = traslado.registro && traslado.registro.creacion;
  return creacion && creacion.toMillis ? creacion.toMillis() : 0;
};

/**
 * Los traslados de un espacio de trabajo: los de quienes salieron de él y los de quienes llegaron.
 * @param {string} idEmpresa
 * @return {Promise<{salidas: Object[], llegadas: Object[]}>}
 */
export async function obtenerTrasladosDelEspacio(idEmpresa) {
  const coleccion = collection(db, COLECCION);
  const [salidas, llegadas] = await Promise.all([
    getDocs(query(coleccion, where("idEmpresa.anterior", "==", idEmpresa))),
    getDocs(query(coleccion, where("idEmpresa.nueva", "==", idEmpresa))),
  ]);
  return { salidas: vigentes(salidas), llegadas: vigentes(llegadas) };
}

/**
 * El traslado más reciente con el que un conductor salió de un espacio de trabajo, o null si nunca salió de
 * él. Con ese registro, el espacio de origen puede consultar la hoja de vida (ver la ruta del conductor).
 * @param {string} idEmpresa - Espacio de origen.
 * @param {string} idConductor
 * @return {Promise<Object|null>}
 */
export async function obtenerSalidaDelConductor(idEmpresa, idConductor) {
  const instantanea = await getDocs(query(
    collection(db, COLECCION),
    where("idEmpresa.anterior", "==", idEmpresa),
    where("idConductor", "==", idConductor),
  ));
  const salidas = vigentes(instantanea).sort((a, b) => momentoTraslado(b) - momentoTraslado(a));
  return salidas[0] || null;
}
